<script setup>
import { computed } from 'vue';
import { badgeVariants } from '@/components/ui/variants';

const props = defineProps({
  tone: { type: String, default: 'ink' },
  size: { type: String, default: 'md' },
  icon: { type: String, default: null },
});

const classes = computed(() => badgeVariants({ tone: props.tone, size: props.size }));
</script>

<template>
  <span :class="classes">
    <iconify-icon v-if="icon" :icon="icon" aria-hidden="true" />
    <slot />
  </span>
</template>
